###
# Использование:
#
# {{sm-typeahead
#
# content=arrayOfDataForTypeahead
# displayKey="somePropertyToDisplayStuff"
#
# }}
###

SmTextFieldComponent = require './sm-text-field'

module.exports = App.SmTypeaheadComponent = SmTextFieldComponent.extend
  minLength       : 1
  highlight       : true
  displayKey      : null
  async           : false
  content         : null

  didInsertElement: ->
    Ember.run.scheduleOnce 'afterRender', @, '_initializeTypeahead'
    return

  _filterContent: (query) ->
    regex = "#{query}".toLowerCase()
    displayKey = @get('displayKey')
    content = @get('content')
    result = []

    if !Ember.isEmpty(content)
      result = content.filter((item) ->
        (if displayKey? then Ember.get(item, displayKey) else item).toLowerCase().indexOf(query.toLowerCase()) != -1
      )

    result

  _initializeTypeahead: ->
    minLength = @get 'minLength'
    highlight = @get 'highlight'
    displayKey = @get 'displayKey'
    async  = @get 'async'
    source  = @get 'source'

    @$().typeahead(
        minLength: minLength
        highlight: highlight
      ,
        display: displayKey
        async: async
        source: (query, cb) =>
          content = @.get('content')

          if Ember.isEmpty(query) or query == '*'
            cb(content)

          cb(@_filterContent(query))

    ).on 'typeahead:selected typeahead:autocompleted', (e, obj, dataSet) =>
      @set('selection', obj)

      displayKey = @get 'displayKey'

      @set('value', if displayKey? then obj[displayKey] else obj)
    return

  _focusOut: (->
    query = @$().typeahead('val')
    return if @get('content') && @get('content').includes query

    results = @_filterContent(query)

    if $.trim(query).length
      if results.length
        @set 'selection', results[0]
    return
  ).on('focusOut')

  _watch_value_changed_outside: (->
    @$().typeahead 'val', @get('value')
  ).observes('value')

  setTypeaheadValue: Ember.observer('selection', ->
    Ember.run.once @, 'setSelectionValue'
    return
  )

  setSelectionValue: ->
    selection = @get('selection')
    displayKey = @get('displayKey')

    if selection?
      value = if displayKey? then Ember.get(selection, displayKey) else selection

    if (value != @$().typeahead 'val') and !(Ember.isEmpty value)
      @$().typeahead 'val', value

    return

  close: ->
    @$().typeahead 'close'
    return

  willDestroyElement: ->
    @$().typeahead 'destroy'
    return
